import $ from 'jquery';

$(function () {
    if ($('#rate_rebound_page').length) {
        $('.site-navigator').css("display", "none");
        $('.site-mobile-navigator').css("display", "none");
    }
});